import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { ColumnBaseModel } from '@smarttask-common/src/lib/models/Table/ColumnBaseModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class ContactViewHubService extends OrganizationHubBase {
    // Pre-existing: contact views share the chat hub's organization group.
    protected subscribe_event = SharedEventNameEnum.chat_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.chat_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.contact_view_upsert, (view_id: string) => {
            this.broadcast(SharedEventNameEnum.contact_view_upsert, { view_id });
        });

        this.on(SharedEventNameEnum.contact_view_order_update, (view_id: string, order_index: number) => {
            this.broadcast(SharedEventNameEnum.contact_view_order_update, { view_id, order_index });
        });

        this.on(SharedEventNameEnum.contact_view_name_update, (view_id: string, name: string) => {
            this.broadcast(SharedEventNameEnum.contact_view_name_update, { view_id, name });
        });

        this.on(SharedEventNameEnum.contact_view_delete, (view_id: string) => {
            this.broadcast(SharedEventNameEnum.contact_view_delete, { view_id });
        });

        this.on(SharedEventNameEnum.contact_view_column_upsert, (view_id: string, column_base: ColumnBaseModel) => {
            this.broadcast(SharedEventNameEnum.contact_view_column_upsert, { view_id, column_base });
        });

        this.on(SharedEventNameEnum.contact_view_column_delete, (view_id: string, column_id: string) => {
            this.broadcast(SharedEventNameEnum.contact_view_column_delete, { view_id, column_id });
        });
    };
}
